import * as React from 'react';
import {useApplicationContext} from './ApplicationContext';


export default function Application(props: any) {
    const {state} = useApplicationContext();

    React.useEffect(() => {
    }, []);


    return props.children;
}
